import { createAction, props } from '@ngrx/store';
// import { ISummaryState } from "./summary.interface";

export const updateSummaryDetails = createAction(
	'[Summary] Update Summary Details',
	props<{ summary: any }>()
);
